import NotInterestedIcon from '@mui/icons-material/NotInterested';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import orderBy from 'lodash/orderBy';
import { DisplayMarkupBox } from '../../components/display-markup';
import { EventRegistrationData, EventTicketData } from '../../types';
import { toCurrency } from '../../utils/formatter';

export function RegisterTicketSelect(props: {
  data: EventRegistrationData;
  ticket: EventTicketData | undefined;
  onSelect: (ticket: EventTicketData | undefined) => void;
}) {
  return (
    <Box>
      <Typography variant="h6" component="div" gutterBottom>
        Ticket Type
      </Typography>

      <Stack spacing={1}>
        {props.ticket ? (
          <Stack spacing={1}>
            <Box
              sx={{
                p: 0,
                pb: 1,
                textAlign: 'left',
                fontFamily: 'Roboto',
                overflow: 'hidden',
                border: '2px solid #9b9b9b',
                backgroundColor: '#fff',
                borderRadius: 2,
              }}
            >
              <Box sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                <Box
                  sx={{
                    p: 1,
                    pl: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <TaskAltIcon />
                </Box>

                {props.ticket.Price !== null ? (
                  <Box
                    sx={{
                      fontFamily: 'Roboto Mono',
                      fontWeight: 'bold',
                      fontSize: 22,
                      color: '#4a4a4a',
                    }}
                  >
                    {props.ticket.Price === 0
                      ? 'Free'
                      : toCurrency({ value: props.ticket.Price })}
                  </Box>
                ) : null}
              </Box>

              <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                <Box sx={{ flex: 1, px: 1.2 }}>
                  <Box
                    sx={{
                      borderLeft: `4px solid ${red[700]}`,
                      pl: 1,
                      fontSize: 18,
                      fontWeight: 'bold',
                      lineHeight: 1.4,
                      letterSpacing: 0.01,
                    }}
                  >
                    {props.ticket.Title}
                  </Box>
                </Box>
              </Box>
            </Box>

            <Button
              fullWidth
              variant="outlined"
              onClick={() => props.onSelect(undefined)}
            >
              Change ticket
            </Button>
          </Stack>
        ) : (
          orderBy(props.data.TicketTypes, 'Price').map((ticket) => {
            // There are not tickets of this type available for purchase
            let soldOut: boolean = false;
            if (ticket.Available !== null && ticket.Available <= 0) {
              soldOut = true;
            }

            return (
              <Box
                key={ticket.TicketTypeId}
                component="button"
                disabled={soldOut}
                onClick={() => props.onSelect(ticket)}
                sx={{
                  p: 0,
                  color: '#000',
                  textAlign: 'left',
                  fontFamily: 'Roboto',
                  overflow: 'hidden',
                  border: '2px solid #ccc',
                  backgroundColor: '#fff',
                  borderRadius: 2,
                  transition: 'all 0.2s',
                  '&:hover': {
                    cursor: 'pointer',
                    border: '2px solid #000',
                  },
                  '&:disabled': {
                    cursor: 'inherit',
                    border: '2px solid #ccc',
                    color: '#0005',
                  },
                }}
              >
                {soldOut ? (
                  <Box
                    sx={{
                      width: '100%',
                      textTransform: 'uppercase',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      background: '#c1c1c1',
                      p: 0.5,
                      color: '#fff',
                    }}
                  >
                    Sold out
                  </Box>
                ) : null}

                <Box sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      p: 1,
                      pl: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {soldOut ? (
                      <NotInterestedIcon />
                    ) : (
                      <RadioButtonUncheckedIcon />
                    )}
                  </Box>

                  {ticket.Price !== null ? (
                    <Box
                      sx={{
                        fontFamily: 'Roboto Mono',
                        fontWeight: 'bold',
                        fontSize: 22,
                        color: soldOut ? '#9b9b9b' : '#4a4a4a',
                      }}
                    >
                      {ticket.Price === 0
                        ? 'Free'
                        : toCurrency({ value: ticket.Price })}
                    </Box>
                  ) : null}
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Box sx={{ flex: 1, px: 1.2 }}>
                    <Box
                      sx={{
                        borderLeft: `4px solid ${red[700]}`,
                        pl: 1,
                        fontSize: 18,
                        fontWeight: 'bold',
                        lineHeight: 1.4,
                      }}
                    >
                      {ticket.Title}
                    </Box>
                    <DisplayMarkupBox
                      markup={ticket.Description}
                      sx={{ fontSize: 14 }}
                    />
                  </Box>
                </Box>
              </Box>
            );
          })
        )}
      </Stack>
    </Box>
  );
}
